import {PageFragment, PageFragmentProps, PageFragmentState} from "@/shared/PageFragment";
import {PageWithSidebarContainer} from "@/shared/PageWithSidebarContainer";
import React, {ReactElement} from "react";
import {SidebarItems} from "@/shared/Sidebar";
import {PathComponent} from "@/shared";
import {BirthdayEmailCampaignFragment} from "./email/BirthdayEmailCampaignFragment";
import {PlaceholderFragment} from "@/shared/PlaceholderFragment";
import {FestivalEmailCampaignFragment} from "./email/FestivalEmailCampaignFragment";
import {BirthdaySmsCampaignFragment} from "./sms/BirthdaySmsCampaignFragment";
import {FestivalSmsCampaignFragment} from "./sms/FestivalSmsCampaignFragment";
import {BirthdayWhatsAppCampaignFragment} from "./whatsapp/BirthdayWhatsAppCampaignFragment";
import {FestivalWhatsAppCampaignFragment} from "./whatsapp/FestivalWhatsAppCampaignFragment";
import {MessageCampaignsOverviewFragment} from "./MessageCampaignsOverviewFragment";

const SIDEBAR_ITEMS: SidebarItems = {
  groups: [
    {
      items: [
        {
          title: "Overview",
          path: "overview",
          render: pathProps => <MessageCampaignsOverviewFragment path={pathProps}/>,
        },
      ],
      variant: "condensed",
    },
    {
      items: [
        {
          title: "Birthday",
          path: "email-birthday",
          render: pathProps => <BirthdayEmailCampaignFragment path={pathProps}/>,
        },
        {
          title: "Festival",
          path: "email-festival",
          render: pathProps => <FestivalEmailCampaignFragment path={pathProps}/>,
        },
      ],
      title: "Email",
      variant: "condensed",
    },
    {
      items: [
        {
          title: "Birthday",
          path: "sms-birthday",
          render: pathProps => <BirthdaySmsCampaignFragment path={pathProps}/>,
        },
        {
          title: "Festival",
          path: "sms-festival",
          render: pathProps => <FestivalSmsCampaignFragment path={pathProps}/>,
        },
      ],
      title: "Sms",
      variant: "condensed",
    },
    {
      items: [
        {
          title: "Birthday",
          path: "whatsapp-birthday",
          render: pathProps => <BirthdayWhatsAppCampaignFragment path={pathProps}/>,
        },
        {
          title: "Festival",
          path: "whatsapp-festival",
          render: pathProps => <FestivalWhatsAppCampaignFragment path={pathProps}/>,
        },
      ],
      title: "Whatsapp",
      variant: "condensed",
    },
  ],
  containerId: "campaigns",
}

export type MessageCampaignsFragmentProps = PageFragmentProps & {}

type MessageCampaignsFragmentState = PageFragmentState & {}

export class MessageCampaignsFragment extends PageFragment<MessageCampaignsFragmentProps, MessageCampaignsFragmentState> {

  static nestedPaths(): PathComponent[] {
    return PageWithSidebarContainer.nestedPathsFromSidebarItems(SIDEBAR_ITEMS);
  }

  renderContent(): ReactElement {
    return <PageWithSidebarContainer path={this.props.path} size="sm" sidebarCollapsible sidebarItems={SIDEBAR_ITEMS}/>;
  }
}